import { LatitudeLongitude } from '@aloft/toolkit-shared';

import { useCallback } from 'react';

import { getConfig } from '../../utils/getConfig.ts';
import { useLocationHasStreetView } from './useLocationHasStreetView.ts';

export const useMakeStreetViewStaticURL = () => {
  const locationHasStreetView = useLocationHasStreetView();
  const apiKey = getConfig('GOOGLE_MAPS_API_KEY');

  const makeStreetViewStaticURL = useCallback(
    async ({ latitude, longitude }: LatitudeLongitude) => {
      if (!locationHasStreetView) return undefined;

      const hasStreetView = await locationHasStreetView({ lat: latitude, lng: longitude });
      if (!hasStreetView) return undefined;

      return `https://maps.googleapis.com/maps/api/streetview?size=400x400&location=${latitude},${longitude}&key=${apiKey}`;
    },
    [locationHasStreetView, apiKey],
  );

  if (!locationHasStreetView) return undefined;

  return makeStreetViewStaticURL;
};
